import React from 'react';
import { SubTitle } from 'components';
import education from 'assets/icons/iconEducation.png';
import classNames from 'classnames';
import './Goals.scss';

const Goal = ({ altStyle }) => {
  const classes = classNames({
    'nw-goal': true,
    'nw-goal--alt': altStyle,
  });
  return (
    <div className={classes}>
      <SubTitle title="Goal" />
      <div className="nw-goal__icon">
        <img src={education} alt="Icon" />
        <h5>Education</h5>
      </div>
      <p>
        <span>Your Education goal can be achieved</span>
        <br />
        <span>within 5 years</span>
      </p>
    </div>
  );
};

export default Goal;
